import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { IMAGES } from "@/data/content";
import { EASE } from "./Reveal";

const lines = [
  { text: "Pins. Bushes.", serif: false },
  { text: "JIC Hydraulics.", serif: true },
  { text: "Built for India.", serif: false },
];

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);
  const bgScale = useTransform(scrollYProgress, [0, 1], [1, 1.12]);
  const fade = useTransform(scrollYProgress, [0, 0.75], [1, 0]);

  return (
    <section ref={ref} id="top" className="hero" data-testid="hero-section">
      <motion.div className="hero-bg" style={{ y: bgY, scale: bgScale }}>
        <img src={IMAGES.hero} alt="Excavator at work — AP Enterprises, excavator spare parts India" fetchpriority="high" />
      </motion.div>
      <div className="hero-overlay" />

      <motion.div className="hero-content" style={{ opacity: fade }}>
        <motion.p
          className="mono-label hero-kicker"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.1, ease: EASE }}
          data-testid="hero-kicker"
        >
          Est. for engineering excellence
        </motion.p>

        <motion.span
          className="hero-chip"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.2, ease: EASE }}
          data-testid="hero-jic-badge"
        >
          ✦ Authorised Master Distributor — JIC Hydraulics · India
        </motion.span>

        <h1 className="hero-title" data-testid="hero-title">
          {lines.map((l, i) => (
            <span className="mask-line" key={i}>
              <motion.span
                className={`mask-line-inner ${l.serif ? "serif-italic" : ""}`}
                initial={{ y: "115%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1.1, delay: 0.25 + i * 0.14, ease: EASE }}
              >
                {l.text}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.p
          className="hero-sub"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1, ease: EASE }}
          data-testid="hero-subtitle"
        >
          AP Enterprises — excavator pins and bushes manufacturer, and authorised
          master distributor of JIC Hydraulics in India. OEM-grade earthmoving
          spare parts and genuine JIC hydraulic pumps &amp; motors.
        </motion.p>

        <motion.a
          href="#products"
          className="btn btn-light"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.15, ease: EASE }}
          data-testid="hero-cta"
        >
          Explore our capabilities <ArrowDown size={16} />
        </motion.a>
      </motion.div>

      <motion.div
        className="hero-footer mono-label"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.4 }}
      >
        <span>OEM-grade components</span>
        <span>Manufactured in India</span>
      </motion.div>
    </section>
  );
};
